<template>
  <div>
    <div class="filter-bar">
      <span @click="selectYear">
        年份 {{ year }}
        <i class="caret"></i>
      </span>
      <span>
        {{ querytype }}
        <i class="caret"></i>
        <select
          class="filter-item__select"
          v-model="querytype"
          @change="searchMonth"
        >
          <option :value="'全部'">全部</option>
          <option :value="'物料'">物料</option>
          <option :value="'供应商'">供应商</option>
          <option :value="'采购员'">采购员</option>
          <option :value="'业务员'">业务员</option>
          <option :value="'业务部门'">业务部门</option>
        </select>
      </span>
    </div>
    <div class="filter-row">
      <div class="filter-info">
        <div class="filter-select">
          <mixed-purchase-order label="" v-model="con" @change="searchText" />
        </div>
        <div class="filter-input">
          <product-field
            v-if="con == '物料'"
            label=""
            v-model="form.pr_detail"
            @select="onSelectProduct($event)"
          />
          <vendor-field
            v-if="con == '供应商'"
            label=""
            v-model="form.pu_vendname"
            @select="onSelectVendor"
          />
          <employee-field
            v-if="con == '采购员'"
            label=" "
            v-model="form.pu_buyername"
            @select="onselectBuyer"
          />
          <employee-field
            label=" "
            v-if="con == '业务员'"
            v-model="form.pd_sellername"
            @select="onselectSeller"
          />
          <department-field
            v-if="con == '业务部门'"
            label=" "
            v-model="form.pd_seller_dpname"
            @select="onSelectDepartment"
          />
        </div>
      </div>
    </div>

    <div class="canvas-box">
      <canvas id="myChart" class="myChart"></canvas>
    </div>

    <div class="list-container" v-if="querytype == '全部' && result.monthitems">
      <div class="list-fixed">
        <p class="list-box-col__title">月份</p>
        <p
          class="list-box-col__content"
          v-for="item in result.monthitems"
          :key="item.text"
        >
          {{ item.text }}
        </p>
        <p class="list-box-col__content">本年累计</p>
      </div>
      <div class="list-scroll">
        <div class="list-scroll-wrap">
          <div
            class="list-box-col"
            @click="initChart(deal2(result.details[0]))"
          >
            <p class="list-box-col__title">订单金额</p>
            <p
              class="list-box-col__content"
              style="color: #2eadf5"
              v-for="item in result.monthitems"
              :key="item.text"
            >
              {{ numberFormat(item.amount, "#,##0.##") || 0 }}
            </p>
            <p class="list-box-col__content" style="color: #2eadf5">
              {{ numberFormat(result.details[0].amount, "#,##0.##") || 0 }}
            </p>
          </div>
          <div
            class="list-box-col"
            @click="initChart(deal2(result.details[1]))"
          >
            <p class="list-box-col__title">待交货金额</p>
            <p
              class="list-box-col__content"
              style="color: #e44959"
              v-for="item in result.monthitems"
              :key="item.text"
            >
              {{ numberFormat(item.waitamount, "#,##0.##") || 0 }}
            </p>
            <p class="list-box-col__content" style="color: #e44959">
              {{ numberFormat(result.details[1].amount, "#,##0.##") || 0 }}
            </p>
          </div>
          <div
            class="list-box-col"
            @click="initChart(deal2(result.details[2]))"
          >
            <p class="list-box-col__title">已收料金额</p>
            <p
              class="list-box-col__content"
              style="color: #16b603"
              v-for="item in result.monthitems"
              :key="item.text"
            >
              {{ numberFormat(item.outamount, "#,##0.##") || 0 }}
            </p>
            <p class="list-box-col__content" style="color: #16b603">
              {{ numberFormat(result.details[2].amount, "#,##0.##") || 0 }}
            </p>
          </div>
          <div
            class="list-box-col"
            @click="initChart(deal2(result.details[3]))"
          >
            <p class="list-box-col__title">订单数量</p>
            <p
              class="list-box-col__content"
              style="color: #2eadf5"
              v-for="item in result.monthitems"
              :key="item.text"
            >
              {{ numberFormat(item.qty, "#,##0.##") || 0 }}
            </p>
            <p class="list-box-col__content" style="color: #2eadf5">
              {{ numberFormat(result.details[3].amount, "#,##0.##") || 0 }}
            </p>
          </div>
          <div
            class="list-box-col"
            @click="initChart(deal2(result.details[4]))"
          >
            <p class="list-box-col__title">待交货数</p>
            <p
              class="list-box-col__content"
              style="color: #e44959"
              v-for="item in result.monthitems"
              :key="item.text"
            >
              {{ numberFormat(item.waitqty, "#,##0.##") || 0 }}
            </p>
            <p class="list-box-col__content" style="color: #e44959">
              {{ numberFormat(result.details[4].amount, "#,##0.##") || 0 }}
            </p>
          </div>
          <div
            class="list-box-col"
            @click="initChart(deal2(result.details[5]))"
          >
            <p class="list-box-col__title">已收料数</p>
            <p
              class="list-box-col__content"
              style="color: #16b603"
              v-for="item in result.monthitems"
              :key="item.text"
            >
              {{ numberFormat(item.outqty, "#,##0.##") || 0 }}
            </p>
            <p class="list-box-col__content" style="color: #16b603">
              {{ numberFormat(result.details[5].amount, "#,##0.##") || 0 }}
            </p>
          </div>
          <div
            class="list-box-col"
            @click="initChart(deal2(result.details[6]))"
          >
            <p class="list-box-col__title">达成率</p>
            <p
              class="list-box-col__content"
              style="color: #1890ff"
              v-for="(item, index) in achievement"
              :key="index"
            >
              {{ numberFormat(item.rate, "#,##0.##") || 0 }}%
            </p>
            <p class="list-box-col__content" style="color: #1890ff">
              {{ numberFormat(result.details[6].amount, "#,##0.##") || 0 }}%
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="list-cells" v-if="querytype != '全部' && result.monthitems">
      <div
        class="list-cell"
        v-for="(item, index) in result.details"
        :key="index"
      >
        <div class="list-cell__main" @click="open(index)">
          <div class="list-cell__index">
            <span>{{ index + 1 }}</span>
          </div>
          <div class="list-cell__content">
            <p v-if="querytype === '物料'">
              {{ item.pr_code }} {{ item.pr_detail }}
            </p>
            <p v-if="querytype === '供应商'">
              {{ item.pu_vendcode }} {{ item.pu_vendname }}
            </p>
            <p v-if="querytype === '采购员'">
              {{ item.pu_buyercode }} {{ item.pu_buyername }}
            </p>
            <p>{{ numberFormat(item.amount, "#,##0.##") || 0 }}</p>
          </div>
          <div class="list-cell__toggle">
            <span v-if="opened == index"
              ><i class="iconfont icon-shang"></i
            ></span>
            <span v-else><i class="iconfont icon-xia"></i></span>
          </div>
        </div>
        <div class="weui-cells" v-if="opened == index">
          <div class="weui-cell gray" v-for="month in 12" :key="month">
            <div class="weui-cell__bd">{{ month }}月</div>
            <div class="weui-cell__ft">
              {{ numberFormat(item["amount" + month], "#,##0.##") || 0 }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="list-empty" v-if="!result.monthitems">暂无数据</div>
  </div>
</template>

<script>
// import F2 from '@antv/f2'
import F2 from "@antv/f2/lib/index";
import ScrollBar from "@antv/f2/lib/plugin/scroll-bar";
import MixedPurchaseOrder from "@/components/field/MixedPurchaseOrder.vue";
import ProductField from "@/components/field/ProductField.vue";
import VendorField from "@/components/field/VendorField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import DepartmentField from "@/components/field/DepartmentField.vue";
import "@antv/f2/lib/interaction/pan";

export default {
  components: {
    // SearchBar,
    MixedPurchaseOrder,
    ProductField,
    VendorField,
    EmployeeField,
    DepartmentField,
  },
  data() {
    return {
      result: {},
      year: new Date().getFullYear(),
      querytype: "全部",
      querytypeObj: {
        全部: "detail",
        物料: "prod",
        供应商: "vend",
        采购员: "buyer",
        业务员: "seller",
        业务部门: "dept",
      },
      opened: -1,
      pr_detail: "",
      qc_prodid: null,
      chart: null,
      con: "全部",
      condition: null,
      form: {
        pr_detail: null,
        pu_vendname: null,
        pu_buyername: null,
        pd_sellername: null,
        pd_seller_dpname: null,
      },
      achievement: [],
    };
  },
  mounted() {
    this.searchMonth();
    window.addEventListener("resize", this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
    if (this.chart) {
      this.chart.destroy();
    }
  },
  methods: {
    clear() {
      this.form = {
        pr_detail: null,
        pu_vendname: null,
        pu_buyername: null,
        pd_sellername: null,
        pd_seller_dpname: null,
      };
    },
    onselectSeller() {
      this.condition = "pd_sellername like '%" + this.form.pd_sellername + "%'";
      this.searchMonth();
    },
    /**
     * 选择部门
     */
    onSelectDepartment() {
      this.condition =
        "pd_seller_dpname like '%" + this.form.pd_seller_dpname + "%'";
      this.searchMonth();
    },
    onselectBuyer() {
      this.condition = "pu_buyername like '%" + this.form.pu_buyername + "%'";
      this.searchMonth();
    },
    onSelectVendor(selection) {
      this.condition = "pu_vendid = " + selection.id;
      this.searchMonth();
    },
    onSelectProduct(selection) {
      this.form.pr_detail = selection.pr_detail;
      this.condition = "pd_prodid = " + selection.id;
      this.searchMonth();
    },
    searchText() {
      this.clear();
      this.condition = null;
      this.searchMonth();
    },
    searchMonth() {
      let me = this,
        year = me.year,
        condition = me.condition,
        querytype = me.querytypeObj[me.querytype];

      let params = {
        year,
        querytype,
        con: condition ? condition : null,
      };
      if (me.qc_prodid) params.con = `qc_prodid like '%${me.qc_prodid}%'`;

      me.$ajax({
        url: "/api/storage/report/purchaseDetailMonth",
        params,
      }).then(function (res) {
        if (res.success) {
          me.result = res.data;
          me.getRate(me.result.details[6]);
          me.initChart(me.deal(me.result.monthitems));
        }
      });
    },
    onResize() {
      var chart = this.chart;
      if (chart) {
        this.chart = chart.destroy();
        this.initChart(this.deal(this.result.monthitems));
      }
    },
    initChart(data) {
      var chart = this.chart;
      if (chart) {
        chart.changeData(data);
        return;
      }
      this.chart = chart = new F2.Chart({
        id: "myChart",
        width: window.innerWidth,
        height: Math.min(window.innerHeight * 0.6, 300),
        pixelRatio: window.devicePixelRatio,
        plugins: ScrollBar,
      });

      chart.source(data, {
        index: {
          type: "linear",
          tickInterval: 1,
          min: -1,
          max: window.innerWidth > window.innerHeight ? 12 : 6,
          formatter: (i) =>
            i > -1 && i < 12
              ? [
                  "01月",
                  "02月",
                  "03月",
                  "04月",
                  "05月",
                  "06月",
                  "07月",
                  "08月",
                  "09月",
                  "10月",
                  "11月",
                  "12月",
                ][i]
              : null,
        },
      });

      chart
        .interval()
        .position("index*value")
        .color("type", (val) => {
          if (val === "订单金额") {
            return "#2eadf5";
          } else if (val === "待交货金额") {
            return "#e44959";
          } else if (val === "已收料金额") {
            return "#16b603";
          } else if (val === "订单数量") {
            return "#2eadf5";
          } else if (val === "待交货数") {
            return "#e44959";
          } else if (val === "已收料数") {
            return "#16b603";
          }
        })
        .adjust({
          type: "dodge",
          marginRatio: 0.05, // 设置分组间柱子的间距
        });

      if (window.innerWidth < window.innerHeight) {
        // 定义进度条
        chart.scrollBar({
          mode: "x",
          xStyle: {
            backgroundColor: "#e8e8e8",
            fillerColor: "#808080",
            offsetY: -2,
          },
        });
      }
      chart.interaction("pan");
      chart.render();
      // this.chart.changeSize(this.pageWidth);
    },
    open(index) {
      if (index != this.opened)
        this.initChart(this.deal2(this.result.details[index]));

      this.opened = index == this.opened ? -1 : index;
    },
    //处理达成率数据
    getRate(data) {
      let me = this;
      me.achievement = [];
      for (var i = 1; i < 13; i++) {
        me.achievement.push({
          rate: data["amount" + i] ? data["amount" + i] : 0,
        });
      }
    },
    deal(data) {
      if (!data) return;

      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: "订单金额", value: 0 },
        { index: 12, type: "订单金额", value: 0 },
      ];
      data.forEach((item, i) => {
        arr.push(
          {
            text: item.text,
            type: "订单金额",
            index: i,
            value: item.amount,
          },
          {
            text: item.text,
            type: "待交货金额",
            index: i,
            value: item.waitamount,
          },
          {
            text: item.text,
            type: "已收料金额",
            index: i,
            value: item.outamount,
          }
        );
      });
      const l = arr.length / 3;
      if (l < 12) {
        for (let i = l; i < 12; i++) {
          arr.push(
            {
              index: i,
              text: textArr[i],
              type: "订单金额",
              value: 0,
            },
            {
              index: i,
              text: textArr[i],
              type: "待交货金额",
              value: 0,
            },
            {
              index: i,
              text: textArr[i],
              type: "已收料金额",
              value: 0,
            }
          );
        }
      }
      return arr;
    },
    deal2(data) {
      if (!data) return;
      const textArr = [
        "01月",
        "02月",
        "03月",
        "04月",
        "05月",
        "06月",
        "07月",
        "08月",
        "09月",
        "10月",
        "11月",
        "12月",
      ];

      let arr = [
        { index: -1, type: data.text, value: 0 },
        { index: 12, type: data.text, value: 0 },
      ];
      for (let i = 0; i < 12; i++) {
        arr.push({
          index: i,
          text: textArr[i],
          type: data.text,
          value: data["amount" + (i + 1)] || 0,
        });
      }
      return arr;
    },
    selectYear() {
      var me = this,
        year = new Date().getFullYear(),
        years = [];
      for (let i = year - 20; i <= year + 20; i++) {
        years.push({
          value: i,
          label: i + "年",
        });
      }
      me.$weui.picker(years, {
        title: "选择年份",
        defaultValue: [year],
        onConfirm: function (r) {
          me.year = r[0].value;
          me.searchMonth();
        },
      });
    },
  },
};
</script>

<style scoped>
.list-empty {
  width: 100%;
  height: 50px;
  text-align: center;
  background: #fff;
  color: #8b8b8b;
  font-size: 12px;
}
.filter-row {
  width: 100%;
  padding: 1px 0px;
  background: #fff;
  /* height: 70px; */
}
.filter-info {
  /* height: 58px; */
  background-color: #fff;
  margin: 10px;
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  justify-content: space-between;
  border: 1px solid var(--weui-FG-3);
}

.filter-select {
  width: 110px;
}
.filter-input {
  flex: 1;
}

.canvas-box {
  /* width: 100%;
  height: 100%; */
  overflow-x: scroll;
  background: var(--weui-BG);
}

.filter-bar {
  width: 100%;
  background: var(--weui-BG-2);
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  padding: 11px 0 9px 0;
  color: #9b9b9b;
  margin-bottom: 1px;
  display: flex;
}
.filter-bar span {
  margin: 0 auto;
  flex: 1;
  position: relative;
}
.filter-item__select {
  position: absolute;
  margin: 0;
  padding: 0;
  border: 0;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.filter-item__select option {
  color: var(--weui-FG-0);
  background: var(--weui-BG-2);
}

.list-container {
  text-align: center;
  line-height: 40px;
  background: var(--weui-BG);
  display: flex;
}
.list-fixed {
  width: 100px;
  border-right: 1px solid var(--weui-FG-3);
}
.list-scroll {
  flex-grow: 1;
  overflow-y: scroll;
}
.list-scroll-wrap {
  width: 180%;
  display: flex;
  justify-content: space-around;
}
.list-box-col:active {
  background: #e0e0e0;
}
.list-box-col__title {
  font-weight: bold;
  /* border: 1px solid; */
}
.list-box-col__content {
  font-size: small;
  color: var(--weui-FG-0);
}

.list-cells {
  margin-top: 5px;
  background: var(--weui-BG);
}
.list-cell {
  background-color: #fff;
}
.list-cell__main {
  display: flex;
  padding: 10px 0;
}
.list-cell__index {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-cell__index span {
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  background-color: #c0c0c0;
}
.list-cell__content {
  flex: 1;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #8b8b8b;

  display: flex;
  justify-content: space-between;

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-cell__toggle {
  width: 36px;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  padding: 0 20px;
}
.gray {
  /* max-height: 300px;
  overflow-y: auto; */
  background: #f4f4f4;
}
@media screen and (min-width: 500px) {
  .filter-bar{
    padding: 6px 0 2px 0;
  }
  .list-scroll-wrap{
    width: 100%;
  }
  .list-container{
    line-height: 25px;
  }
  .filter-row{
    display: none;
  }
  
}
</style>